export default __webpack_public_path__ + "a4886fe18917294b63f8ae04d6e91b97.svg";